











































import { Component, Vue, Prop } from "vue-property-decorator";
import { ContentStreamBillingConfigurationDTO } from "../../Generated/ParticaAPI";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";

@Component(
	{
		name: "ContentStreamBillingConfigurationForm",
		components: { ButtonList }
	})
export default class ContentStreamBillingConfigurationForm extends ParticaBaseForm<ContentStreamBillingConfigurationDTO> {

	private numberArticlesconfig =
		{
			props: {
				name: "numberArticles",
				placeholder: "Enter Number Articles",
				label: "Number of articles per issue.",
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private maximumValueContentconfig =
		{
			props: {
				name: "maximumValueContent",
				placeholder: "Enter Maximum Value",
				label: "Maximum value for content in an issue.",
			} as FormFieldProps,
			rules: { required: true, decimal: 2 } as FormFieldRules
		} as IFormField;

	private contentChargeconfig =
		{
			props: {
				name: "contentCharge",
				placeholder: "Enter Content Charge",
				label: "Article charge, per issue, for each subscriber. Owners get the % specified below.",
			} as FormFieldProps,
			rules: { required: true, decimal: 2 } as FormFieldRules
		} as IFormField;


	private billingDayconfig =
		{
			props: {
				name: "billingDay",
				placeholder: "Enter Billing Day",
				label: "The day each month each subscriber will be billed.",
			} as FormFieldProps,
			rules: { required: true, max_value: 28, min_value: 1, numeric: true } as FormFieldRules
		} as IFormField;

	private ownerPercentageContentChargeconfig =
		{
			props: {
				name: "WritersPercentageContentCharge",
				placeholder: "Enter Writers % Content Charge",
				label: "Owners % Content Charge",
			} as FormFieldProps,
			rules: { required: true, max_value: 100, min_value: 1, numeric: true } as FormFieldRules
		} as IFormField;


}
